// extracted by mini-css-extract-plugin
export default {"highlightedText":"highlighted-text-module__highlightedText--NkGwr"};